<template>
  <div
    v-bind:style="showModal ? {display: 'block'} : {display: 'none'}"
    class="modal"
    id="infoModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="myModalLabel"
    aria-hidden="true"
    style="display: none;"
  >
    <div class="modal-dialog modal-info modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">Detalle de incidente</h4>
          <button
            @click="close"
            class="close"
            type="button"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div v-if="ot.incident" class="modal-body body-custom">
          <b-card header="Comentarios de Conductor">
            <div>{{ot.incident.comments}}</div>
          </b-card>
          <div class="table-responsive tableFixHead">
            <table class="table table-sm table-bordered table-hover table-striped">
              <thead>
                <tr>
                  <th>Formulario de conductor</th>
                  <th>OK?</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(item,k) in driverItems"
                  :key="k"
                  href="#"
                  active
                  class="flex-column align-items-start"
                >
                  <td>{{item.name}}</td>
                  <td>
                    <span v-if="item._pivot_answer" class="badge badge-pill badge-success">Si</span>
                    <span v-else class="badge badge-pill badge-danger">No</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <b-card header="Comentarios del Mecánico">
            <div>{{ot.comments}}</div>
          </b-card>
          <div class="table-responsive tableFixHead">
            <table class="table table-sm table-bordered table-hover table-striped">
              <thead>
                <tr>
                  <th>Formulario mecánico</th>
                  <th>Si</th>
                  <th>No</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(item,k) in mechItems"
                  :key="k"
                  href="#"
                  active
                  class="flex-column align-items-start"
                >
                  <td>{{item.name}}</td>
                  <td>
                    <span v-if="item._pivot_answer" class="badge badge-pill badge-success">X</span>
                  </td>
                  <td>
                    <span v-if="!item._pivot_answer" class="badge badge-pill badge-danger">X</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/helpers/api";
import constants from "@/constants";

export default {
  name: "DetailModal",
  props: ["ot", "showModal"],
  data() {
    return {
      driver: null
    };
  },
  mounted() {
    api.get(`/roles`).then(res => {
      this.driver = res.roles.find(role => role.code === constants.CONDUCTOR);
    });
  },
  computed: {
    driverItems() {
      const { incident } = this.ot;
      if (incident && incident.items && this.driver) {
        const data = incident.items.filter(it => it.role_id === this.driver.id);
        console.log(incident, this.driver);
        return incident.items.filter(it => it.role_id === this.driver.id);
      }

      return [];
    },
    mechItems() {
      const { incident } = this.ot;
      if (incident && incident.items)
        return incident.items.filter(it => it.role_id !== this.driver.id);

      return [];
    }
  },
  methods: {
    close(e) {
      this.$emit("close");
    }
  }
};
</script>
